import React, { FC } from "react";
import classNames from "classnames";
import { Body } from "features/BaseDocumentsLayout/Body";
import { useSetAtom } from "jotai";
import { useAtom } from "jotai/index";
import { DocumentsData } from "constant-data/documentsData";
import { Footer } from "features/BaseDocumentsLayout/Footer";

import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { BoldText } from "components/BoldText/BoldText";
import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { setDocumentModalAtom } from "../../atoms/modalAtom/modalAtom";
import { selectedDocumentTypeAtom } from "../../atoms/documentsAtom";

import { Header } from "./Header";
import styles from "./styles.module.css";

interface BaseDocumentsLayoutProps {
  title?: string;
}

export const BaseDocumentsLayout: FC<
  BaseDocumentsLayoutProps
> = ({}): JSX.Element => {
  const [selectedDocumentType] = useAtom(selectedDocumentTypeAtom);

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3 px-8")}
      header={<BoldText>{selectedDocumentType?.name}</BoldText>}
      footer={<Footer />}
    >
      {selectedDocumentType?.id && (
        <div className={styles.container}>
          <Header
            inputs={DocumentsData[selectedDocumentType.id]?.mainFilters}
          />
          <Body
            mainColumns={DocumentsData[selectedDocumentType.id]?.mainColumns}
            bottomRow={DocumentsData[selectedDocumentType.id]?.bottomRow}
          />
          {/*{children}*/}
        </div>
      )}
    </BaseLayout>
  );
};
